import Amplify, { Auth } from 'aws-amplify';

Amplify.configure({
  Auth: {
    region: process.env.REACT_APP_AWS_REGION,
    userPoolId: process.env.REACT_APP_AWS_USER_POOL_ID,
    userPoolWebClientId: process.env.REACT_APP_AWS_USER_POOL_WEB_CLIENT_ID,
  },
});

export const getToken = async (): Promise<string | null> => {
  try {
    const session = await Auth.currentSession();
    return session.getAccessToken().getJwtToken();
  } catch (e) {
    return null;
  }
};

export const cacheWithAsyncRefresh = async (asyncSupplier: any) => {
  let value: any;

  const asyncRefresh = async () => (value = await asyncSupplier());

  // Warm cache
  await asyncRefresh();

  return () => {
    asyncRefresh().catch(console.error);
    return value;
  };
};
